// src/hooks/useProductOrder.ts
import { useApi } from "@/src/api/useApi";
import { DataProductCheckType, ProductCheckType } from "@/src/types/product";
import { useEffect, useState } from "react";
import useCartStore, { CartItem } from "../store/useCartStore";

type CheckedProduct = DataProductCheckType & {
  count: number;
  property?: CartItem["property"];
  /** هشدارها برای نمایش به کاربر */
  warnings: string[];
  /** آیا قیمت یا تخفیف تغییر کرده؟ */
  priceChanged: boolean;
};

export const useProductOrder = () => {
  const cart = useCartStore((s) => s.cart);
  const ids = cart.map((i) => i.ProductIdentityId).join(",");

  const { data: response, isLoading } = useApi<ProductCheckType>(
    ids ? `/product-check?list=[${ids}]` : null
  );

  const [listProduct, setListProduct] = useState<CheckedProduct[]>([]);

  useEffect(() => {
    if (!response?.data) return;

    const merged: CheckedProduct[] = response.data.map((product) => {
      const match = cart.find((c) => c.ProductIdentityId === product.id);
      const wh = product.Warehouses[0]; // فرض: همیشه یکی است
      const cnt = match?.count ?? 0;
      const price = match?.unitDiscount || match?.unitPrice || 0;

      const priceNow =
        wh.warehouse_discount > 0 ? wh.warehouse_discount : wh.warehouse_price;

      /* شناسایی هشدارها */
      const warnings: string[] = [];

      if (!wh.warehouse_available || wh.warehouse_count === 0) {
        warnings.push("ناموجود");
      } else if (wh.warehouse_count < cnt) {
        warnings.push(`حداکثر موجودی ${wh.warehouse_count} عدد است`);
      }

      if (price && priceNow !== price) warnings.push("قیمت تغییر کرده است");

      return {
        ...product,
        count: cnt,
        property: match?.property,
        warnings,
        priceChanged: priceNow !== price,
      };
    });

    setListProduct(merged);
  }, [response, cart]);

  /* هر محصولی که حتی یک هشدار داشته باشد */
  const hasIssue = listProduct.some((p) => p.warnings.length);

  return { data: listProduct, loading: isLoading, hasIssue };
};
